import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpClient, HttpEvent, HttpRequest } from '@angular/common/http';
import { BehaviorSubject, timeout } from 'rxjs';
import { HttpService } from '../_services/http.service'
import { Observable, throwError } from 'rxjs';
import { ConfigService } from './config.service';
import { NotificationData } from '../_models/notification.model';
import { NotificationRequestDto } from './notification.dto';


const API_EXT = '/notification/'

@Injectable({
  providedIn: 'root',
})

export class NotificationService {

  constructor(
    private http: HttpClient,
    private httpService:HttpService,
    private configService: ConfigService

  ) { }

  private get api_url(): string {
    const base = this.configService.getApiBaseUrl(); // OK si config chargée
    return base + API_EXT;
  }

  private notificationSubject = new Subject<NotificationData>();

  // Observable pour écouter les notifications
  notifications$ = this.notificationSubject.asObservable();

  // Méthode pour émettre une notification
  addNotification(notification: NotificationData) {
    this.notificationSubject.next(notification);
  }

  notifEvol(request: NotificationRequestDto): Observable<void> {

    return this.http.post<void>(
      this.api_url,
      request, 
      this.httpService.httpOptions
    )
  }

}
